import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import findIndex from 'lodash/findIndex'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import EnhancedQuantityCell from '../EnhancedQuantityCell/EnhancedQuantityCell'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { stores } from '@stores'
import { OrderType } from '@api/common'
import { MessageDialog } from '@components/UI-Components/MessageDialog'
import { useTranslation } from 'react-i18next'
import { useEnhancedQuantity } from './useEnhancedQuantity'
import { isRetailClient } from '@utils/get-channel-name'

// TODO: Remove this unnecessary wrapper (refactor into EnhancedQuantityCell)
export const EnhancedQuantity: FC<CellItem> = ({
  rowData,
  column,
  visibleColIndex,
  isActive
}) =>
  useObserver(function useHook() {
    const viewContextVal = useViewContext()
    const store = viewContextVal.uiStore as EnhancedListUIStore<any>
    const {
      showProductSizes,
      bookUnbookDoors,
      getSizes,
      navigateToNextEditableCell,
      navigateToPrevAvailableCell,
      handleDoorQtyUpdate,
      getProductSizeCurve,
      splitOrRollupDoorQuantities,
      handleDoorSizeQtyUpdate,
      activeItemStore: { setRowAndColIndex, setSizeIndex, sizeIndex },
      dataStore: { itemIndexObjectStore }
    } = store

    const {
      nav: {
        queryParams: { orderType, clientType }
      },
      productConfiguration: { featureFlags, hideSplitQuantity }
    } = stores

    const {
      uiStore: {
        dataStore: { summary },
        isOrderEditable
      }
    } = useOrderContext()
    const { t } = useTranslation()

    const {
      doorProduct,
      sizeQuantityChangeHandler,
      bookUnbookStatusChangeHandler,
      handleSplitOrRollupDoorsQty,
      draftQtyChangeHandler,
      focus,
      navigate,
      disabled,
      isBookOpPending,
      isHardExcluded,
      highlightDoors,
      availableProductSizes,
      doorToSizeQuantityDistributionToggle,
      sizes,
      captureSizeEnabled,
      openDialog,
      setOpenDialog,
      isBooked,
      cellRef
    } = useEnhancedQuantity({
      orderType,
      rowData,
      runFocusInputEffect: true,
      summary,
      isOrderEditable,
      doorId: column?.field,
      clientType,
      isActive,
      showProductSizes,
      itemIndexObjectStore,
      visibleColIndex,
      sizeIndex,
      hideSplitQuantity,
      getSizes,
      navigateToNextEditableCell,
      navigateToPrevAvailableCell,
      setRowAndColIndex,
      setSizeIndex,
      handleDoorQtyUpdate,
      getProductSizeCurve,
      splitOrRollupDoorQuantities,
      bookUnbookDoors,
      handleDoorSizeQtyUpdate
    })

    const isRetail = isRetailClient(clientType)

    if (!rowData) return <></>

    return (
      <>
        <EnhancedQuantityCell
          disabled={disabled}
          label={!isRetail ? t('orderTable.cnfWhlActualQty', 'Draft Quantity') : ''}
          isBookOpPending={isBookOpPending}
          isHardExcluded={isHardExcluded}
          isBooked={isBooked}
          doorProduct={orderType === OrderType.Door ? rowData : doorProduct}
          highlightDoors={
            featureFlags?.highlightBookUnbookDoorDiscrepanciesInSHR && highlightDoors
          }
          onIsBookedChanged={bookUnbookStatusChangeHandler}
          navigateToCell={navigate}
          navigateToSize={sizeIndex => {
            focus()
            setSizeIndex(sizeIndex)
          }}
          onTotalByDraftQuantityChange={draftQtyChangeHandler}
          onTotalByDraftQuantityFocus={() => {
            focus()
            setSizeIndex(-1)
          }}
          onTotalByDraftQuantityKeyDown={() => {}}
          onTotalByDraftQuantityMouseDown={() => {}}
          showSizeQuantitySummary={captureSizeEnabled}
          sizes={sizes}
          productHasSizes={!!availableProductSizes.length}
          onSizeQuantityMouseDown={() => {}}
          onSizeQuantityChange={sizeQuantityChangeHandler}
          onSizeQuantityKeyDown={() => {}}
          onSizeQuantityFocus={sizeId => {
            focus()
            setSizeIndex(findIndex(sizes, ['id', sizeId]))
          }}
          onBlurHandler={() => {
            setRowAndColIndex(-1, -1)
          }}
          showBookCheckbox={true}
          ref={cellRef}
          doorToSizeQuantityDistributionToggle={doorToSizeQuantityDistributionToggle}
          handleSplitOrRollupDoorsQty={handleSplitOrRollupDoorsQty}
        />
        {openDialog ? (
          <MessageDialog
            open={openDialog}
            title={t('common.label.notAllowed', 'Not Allowed')}
            message={t(
              'order.messages.splitToSizeErrorMessage',
              'Sorry, but there is no size distribution information available, please contact your showroom administrator for help.'
            )}
            handleClose={() => {
              setOpenDialog(false)
            }}
            closeButtonTitle={t('bb.common.label.ok', 'Ok')}
          />
        ) : null}
      </>
    )
  })
